module.exports = __webpack_public_path__ + "static/img/abtus_banner.dd88476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/abtus_banner.png
// module id = SYPL
// module chunks = 0